import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse,
    HttpResponse, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpUserEvent } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map, catchError, tap, switchMap, finalize, filter, take } from 'rxjs/operators';
import { throwError, BehaviorSubject } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';


@Injectable()
export class TokenInterceptorService implements HttpInterceptor {

    skippUrls = [
        'o/token'
      ];
    isRefreshingToken = false;
    tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

    constructor(public authService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse
    | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {

        // let displayLoadingScreen = true;
        // for (const skippUrl of this.skippUrls) {
        //     if (new RegExp(skippUrl).test(request.url)) {
        //       displayLoadingScreen = false;
        //       break;
        //     }
        //   }

        // // if (displayLoadingScreen)
            return next.handle(request).pipe(
                catchError((error: HttpErrorResponse) => {
                    if (error.status === 401) {
                        return this.handle401Error(request, next);
                    }
                    return throwError(error);
                }));
    }

    handle401Error(request: HttpRequest<any>, next: HttpHandler) {
        if (!this.isRefreshingToken) {
            this.isRefreshingToken = true;
            this.tokenSubject.next(null);
            return this.authService.refresh_token().pipe(
                switchMap(resp => {
                    if (resp) {
                        //this.isRefreshingToken = false;
                        this.tokenSubject.next(resp);
                        localStorage.setItem('tokenCF', JSON.stringify(resp));
                        request = request.clone({
                            setHeaders: { Authorization: 'Bearer ' + resp.access_token }
                        });
                        return next.handle(request);
                    }
                }),
                catchError(err => {
                    //this.authService.logout();
                    return throwError(err.error);
                }),
                finalize(() => {
                    this.isRefreshingToken = false;
                }));
        } else {
            this.isRefreshingToken = false;
            return this.tokenSubject
                .pipe(filter(token => token != null),
                    take(1),
                    switchMap(token => {
                        return next.handle(request);
                    }));
        }
    }
}
